module.exports = __webpack_public_path__ + "static/unilever.64648404.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/unilever.svg
// module id = 427
// module chunks = 221427640695397